import { clientStoreWatcherHandler, useClientStore } from '@/stores/ClientStore.ts';
import { settingsStoreWatcherHandler, useSettingsStore } from '@/stores/SettingsStore.ts';
import { promptStoreWatcherHandler, usePromptStore } from '@/stores/PromptStore.ts';
import { sourceStoreWatcherHandler, useSourceStore } from '@/stores/SourceStore.ts';

export const syncStoresToWebViewAction = (): void => {
    // Client store
    const clientStore = useClientStore();
    clientStoreWatcherHandler(
        clientStore.streamsWaiting,
        clientStore.streamStartDates,
        clientStore.sessionVariables,
        clientStore.verticalNavigationOptions,
        clientStore.verticalNavigationSelection,
        clientStore.activeSessionId,
        clientStore.activeProfileId,
        clientStore.screenCaptureRevisions,
    );

    // Settings store
    const settingsStore = useSettingsStore();
    settingsStoreWatcherHandler(
        settingsStore.lastSeenChangelogVersion,
        settingsStore.selectedProfileId,
        settingsStore.hotkeys,
        settingsStore.loggingLevel,
    );

    // Prompt store
    const promptStore = usePromptStore();
    promptStoreWatcherHandler(
        promptStore.profileConfigsString,
        promptStore.stepConfigsString,
        promptStore.promptConfigsString,
        promptStore.variableConfigsString,
    );

    // Prompt store
    const sourceStore = useSourceStore();
    sourceStoreWatcherHandler(
        sourceStore.sources,
        sourceStore.selectedSourceId,
        sourceStore.selectedSourceName,
    );
};
